<template>
  <div class="main-content">
    <a-t-loader v-if="isLoadingAllInvoices"/>

    <template v-else>

      <div class="page-content">
        <div class="efd-invoice-container">
          <section class="efd-invoice-block">
            <div class="page-title">
              <h2>Invoices EFD</h2>
            </div>

            <div class="page-top">
              <div class="tabs-nav">
                <a class="no-efd"
                   :class="['tabs-nav__item', {active: tab === 0}]"
                   @click="
                      pagination.page = 1
                      findTabs(0)
                   ">
                  <svg width="30px" height="30px"  class="icon">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#no-efd"></use>
                  </svg>
                  <span class="tabs-nav__text">No EFD</span>
                </a>
                <a class="efd-printed"
                   :class="['tabs-nav__item', {active: tab === 1}]"
                   @click="
                       pagination.page = 1
                      findTabs(1)
                    ">
                  <svg width="30px" height="30px" class="icon">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#efd-printed"></use>
                  </svg>
                  <span class="tabs-nav__text">EFD Printed</span>
                </a>
              </div>
              <div class="filters-block">
                <div class="filters-block__btn">
                    <span @click="clearSearchInvoice" class="story-templates__table__top-clear">Clear</span>
                </div>
                <div class="filters-block__manager">
                  <v-select
                      v-model="filterSearchInvoice.userId"
                      :options="allClients"
                      :reduce="(item) => item.id"
                      :filterable="false"
                      :clearable="false"
                      :searchable="false"
                      label="firstName"
                      placeholder="Manager"
                      class="new-select"
                  >

                    <template #open-indicator>
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="5"
                          viewBox="0 0 8 5"
                          fill="none">
                        <path
                            d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                            fill="#606060" />
                      </svg>
                    </template>
                    <template #option="option">
                      <div class="select__item d-center">
                        <div class="managers-list__item__image h-object-fit">
                          <img v-if="allClients.find((u) => u.id === option.id).photo"
                              :src="`${API}/documents/share/images/${
                              allClients.find((u) => u.id === option.id)
                                ? allClients.find((u) => u.id === option.id).photo
                                : '797d11d3-ab79-4d9a-b68e-7410b4c1dd3c'
                            }?size=SMALL`"
                              alt="image" />
                          <span v-else></span>
                        </div>
                        <span>{{ option.firstName }}</span>
                      </div>
                    </template>
                    <template #selected-option="option">
                      <div class="selected d-center">
                        <div class="managers-list__item__image h-object-fit">
                          <img v-if="allClients.find((u) => u.id === option.id).photo"
                              :src="`${API}/documents/share/images/${
                              allClients.find((u) => u.id === option.id)
                                ? allClients.find((u) => u.id === option.id).photo
                                : '797d11d3-ab79-4d9a-b68e-7410b4c1dd3c'
                            }?size=SMALL`"
                              alt="image" />
                          <span v-else></span>
                        </div>
                        <span>{{ option.firstName }}</span>
                      </div>
                    </template>

                  </v-select>
                </div>
                <div v-if="tab === 1" class="filters-block__date">
                  <div class="form-control-group">
                    <div class="form-control-wrap">
                      <input
                          type="text"
                          ref="tourStart"
                          v-model="filterSearchInvoice.dateOfEfd"
                          @blur="
                          filterSearchInvoice.dateOfEfd = $event.target.value
                        "
                          Placeholder="Date OF EFD"
                          class="form-control js-datepicker-single" />
                      <div class="form-control-icon">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-calendar">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="filters-block__btn">
                  <button @click="searchInvoice">
                    <svg width="1em" height="1em" class="icon icon-search">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div class="efd-invoice__list">
              <div class="efd-invoice__list-top">
                <div class="efd-invoice__list-top-checkbox">
                  <span>EFD</span>
                </div>
                <div class="efd-invoice__list-top-date">
                  <span>Date of EFD</span>
                </div>
                <div class="efd-invoice__list-top-number">
                  <span>Invoice #</span>
                </div>
                <div class="efd-invoice__list-top-manager">
                  <span>Manager</span>
                </div>
                <div class="efd-invoice__list-top-payer">
                  <span>Payer</span>
                </div>
                <div class="efd-invoice__list-top-total-amount">
                  <span>Amount Paid</span>
                </div>
                <div class="efd-invoice__list-top-ex-rate">
                  <span>Ex. Rate</span>
                </div>
                <div class="efd-invoice__list-top-total-amount-tsh">
                  <span>Amount Paid TSH</span>
                </div>
                <div class="efd-invoice__list-top-exempted-amount">
                  <span>Exempted Amount</span>
                </div>
                <div class="efd-invoice__list-top-vatable-amount">
                  <span>VATable amount</span>
                </div>
                <div class="efd-invoice__list-top-payer">
                  <span>Payment Method</span>
                </div>
              </div>
            </div>

            <template v-if="efdInvoice.length > 0">
              <div class="efd-invoice__item" v-for="invoice in efdInvoice" :key="invoice.id">
                <div class="efd-invoice__item-checkbox">
                  <div class="form-control-group make-story__checkbox">
                    <label class="form-control-checkbox" @click="targetEfdInvoice(invoice)">
                      <input
                          type="checkbox"
                          v-model="invoice.efd"
                          :disabled="invoice.efd"
                      />
                      <span class="form-control-checkbox__box">
                      <svg width="1em" height="1em" class="icon icon-check">
                       <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                      </svg>
                    </span >
                    </label>

                  </div>
                </div>
                <div class="efd-invoice__item-date">
                  <span>{{invoice.dateOfEFD ? parseDateToString(invoice.dateOfEFD) : '-'}}</span>
                </div>
                <div class="efd-invoice__item-number">
                  <router-link v-if="!user.scope.includes('ACCOUNTANT')" :to="{ name: 'changeInvoice', params: { id: invoice.id }}">
                    {{invoice.invoiceNumber}}
                  </router-link>
                  <a v-if="user.scope.includes('ACCOUNTANT')">{{invoice.invoiceNumber}}</a>
                </div>
                <div class="efd-invoice__item-manager">
                  <div class="managers-list__item__image h-object-fit">
                    <img v-if="allClients.find((u) => u.id === invoice.userId)
                                ? allClients.find((u) => u.id === invoice.userId).photo
                                : null "
                        :src="`${API}/documents/share/images/${
                              allClients.find((u) => u.id === invoice.userId)
                                ? allClients.find((u) => u.id === invoice.userId).photo
                                : '797d11d3-ab79-4d9a-b68e-7410b4c1dd3c'
                            }?size=SMALL`"
                        alt="image" />
                    <span v-else></span>
                  </div>

                  <span>
                     {{allClients.find((u) => u.id === invoice.userId)
                      ? allClients.find((u) => u.id === invoice.userId).firstName
                      : ''}}
                   </span>
                </div>
                <div class="efd-invoice__item-payer">
                <span>
                     {{findNamePartners(invoice)}}
                </span>
                </div>
                <div class="efd-invoice__item-total-amount">
                  <span>{{invoice.amountPaid ? `${numberWithCommas(invoice.amountPaid)}` : '-'}}</span>
                  <span>{{getCurrencySign(invoice.currencyType)}}</span>
                </div>
                <div class="efd-invoice__item-ex-rate">
                  <span>{{invoice.exRate ? numberWithCommas(invoice.exRate) : '-'}}</span>
                </div>
                <div class="efd-invoice__item-total-amount-tsh">
                  <span>{{invoice.amountPaidTZS ? `${numberWithCommas(invoice.amountPaidTZS)} Tsh` : '-'}}</span>
                </div>
                <div class="efd-invoice__item-exempted-amount">
                  <span>{{invoice.exemptedAmountTZS ? `${numberWithCommas(invoice.exemptedAmountTZS)} Tsh` : '-'}}</span>
                </div>
                <div class="efd-invoice__item-vatable-amount">
                  <span>{{invoice.vatAmountTZS ? `${numberWithCommas(invoice.vatAmountTZS)} Tsh` : '-'}}</span>
                </div>
                <div class="efd-invoice__item-payment-method">
                  <span> {{invoice.paymentMethod}} </span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="invoices_item-no">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.3752 13.124C16.7204 13.124 17.0002 12.8442 17.0002 12.499C17.0002 12.1538 16.7204 11.874 16.3752 11.874H16.3748C16.0296 11.874 15.75 12.1538 15.75 12.499C15.75 12.8442 16.0301 13.124 16.3752 13.124Z" fill="#77B017"/>
                  <path d="M19.5002 13.124C19.8454 13.124 20.1252 12.8442 20.1252 12.499C20.1252 12.1538 19.8454 11.874 19.5002 11.874H19.4998C19.1546 11.874 18.875 12.1538 18.875 12.499C18.875 12.8442 19.1551 13.124 19.5002 13.124Z" fill="#77B017"/>
                  <path d="M22.6252 13.124C22.9704 13.124 23.2502 12.8442 23.2502 12.499C23.2502 12.1538 22.9704 11.874 22.6252 11.874H22.6248C22.2796 11.874 22 12.1538 22 12.499C22 12.8442 22.2801 13.124 22.6252 13.124Z" fill="#77B017"/>
                  <path d="M30.5016 19.6976C30.4297 19.4463 30.3201 19.211 30.1795 18.998C31.3718 17.043 32 14.8053 32 12.4995C32 5.60727 26.3927 0 19.5005 0C16.2142 0 13.2201 1.27476 10.9866 3.3558C10.5161 2.90594 9.88256 2.64333 9.21709 2.64333C9.14072 2.64333 9.06453 2.6467 8.98879 2.65345C8.30869 1.78443 7.25142 1.25945 6.13634 1.25945C4.35029 1.25945 2.86254 2.56083 2.57174 4.26533C1.52022 4.38982 0.702065 5.28672 0.702065 6.37111C0.702065 7.54038 1.6489 8.49165 2.81279 8.49165H7.6599C7.23273 9.75029 7.00099 11.0983 7.00099 12.4995C7.00099 15.0523 7.77021 17.4287 9.08903 19.4093L0.804936 27.3482C0.801748 27.3513 0.798561 27.3544 0.795436 27.3575C-0.265145 28.4181 -0.265145 30.1439 0.795436 31.2045C1.32573 31.7348 2.02232 32 2.71892 32C3.41552 32 4.11211 31.7348 4.6424 31.2045C4.64553 31.2014 4.64865 31.1982 4.65172 31.195L12.5903 22.9107C14.5711 24.2296 16.9476 24.9989 19.5005 24.9989C21.4614 24.9989 23.3366 24.5583 25.0764 23.689H29.9688C31.0888 23.689 32 22.7778 32 21.6579C32 20.7221 31.364 19.9322 30.5016 19.6976ZM2.81285 7.24164C2.34625 7.24164 1.95208 6.84297 1.95208 6.37105C1.95208 5.89101 2.34262 5.50046 2.82267 5.50046H3.14521C3.49039 5.50046 3.77019 5.22066 3.77019 4.87549C3.77019 3.57079 4.83165 2.50933 6.13634 2.50933C6.97506 2.50933 7.73403 2.93925 8.16657 3.65948C8.31107 3.90003 8.59812 4.01484 8.86854 3.94015C8.98147 3.90903 9.09872 3.89322 9.21709 3.89322C9.55439 3.89322 9.87569 4.02534 10.1157 4.25195C9.32984 5.1451 8.66918 6.15087 8.16132 7.2417H2.81285V7.24164ZM3.75431 30.325C3.18071 30.894 2.25113 30.8925 1.67934 30.3207C1.10749 29.7489 1.10605 28.8193 1.67503 28.2457L7.33767 22.819L9.18084 24.6622L3.75431 30.325ZM10.0457 23.7595L8.24026 21.9539L9.83919 20.4216C10.3606 21.0564 10.9433 21.639 11.578 22.1605L10.0457 23.7595ZM8.25101 12.4994C8.25101 6.29643 13.2975 1.24989 19.5005 1.24989C25.7035 1.24989 30.7501 6.29643 30.7501 12.4994C30.7501 14.4934 30.2285 16.4303 29.2363 18.1391C28.8783 17.9485 28.4714 17.8406 28.0425 17.8406C28.0132 17.8406 27.9839 17.8411 27.9548 17.8421C28.9674 16.2446 29.5001 14.4086 29.5001 12.4995C29.5001 6.98571 25.0143 2.4999 19.5005 2.4999C17.8801 2.4999 16.2699 2.89726 14.8439 3.64904C14.5386 3.81003 14.4215 4.18802 14.5824 4.49338C14.7434 4.79868 15.1214 4.91567 15.4268 4.75481C16.6737 4.09727 18.0824 3.74978 19.5005 3.74978C24.325 3.74978 28.2501 7.67487 28.2501 12.4994C28.2501 14.1273 27.8077 15.6942 26.9656 17.0661C26.3793 16.6762 25.6826 16.4568 24.9618 16.4568C23.1757 16.4568 21.6879 17.7583 21.3972 19.4627C20.4509 19.5747 19.6937 20.3122 19.5515 21.2491C19.5352 21.2491 19.5182 21.2491 19.5005 21.2491C14.676 21.2491 10.7509 17.324 10.7509 12.4994C10.7509 11.0812 11.0983 9.6726 11.7556 8.42597C11.9166 8.1206 11.7996 7.74262 11.4942 7.58163C11.1889 7.42063 10.8109 7.53769 10.6499 7.84299C9.89825 9.26868 9.50089 10.8789 9.50089 12.4994C9.50089 18.0132 13.9866 22.499 19.5005 22.499C19.5927 22.499 19.6691 22.4988 19.7411 22.4975C20.0147 23.0591 20.5283 23.4821 21.1467 23.6309C20.6067 23.7095 20.0575 23.749 19.5005 23.749C13.2975 23.749 8.25101 18.7024 8.25101 12.4994ZM29.9689 22.4391H21.6382C21.1716 22.4391 20.7774 22.0404 20.7774 21.5685C20.7774 21.0884 21.168 20.6979 21.648 20.6979H21.9706C22.3157 20.6979 22.5955 20.4181 22.5955 20.0729C22.5955 18.7682 23.657 17.7068 24.9617 17.7068C25.8005 17.7068 26.5594 18.1367 26.9919 18.8569C27.1364 19.0975 27.4234 19.2123 27.6939 19.1375C27.8069 19.1063 27.9241 19.0906 28.0424 19.0906C28.7227 19.0906 29.295 19.621 29.3456 20.2982C29.3699 20.6244 29.6417 20.8766 29.9688 20.8766C30.3996 20.8766 30.75 21.2271 30.75 21.6579C30.75 22.0887 30.3996 22.4391 29.9689 22.4391Z" fill="#77B017"/>
                  <path d="M12.8713 6.49561C13.2165 6.49561 13.4963 6.21579 13.4963 5.87061C13.4963 5.52542 13.2165 5.24561 12.8713 5.24561H12.8708C12.5257 5.24561 12.2461 5.52542 12.2461 5.87061C12.2461 6.21579 12.5261 6.49561 12.8713 6.49561Z" fill="#77B017"/>
                </svg>
                <span class="title">No Results</span>
                <span class="desc">There’s no invoices yet</span>
              </div>
            </template>

          </section>
          <pagination
              :page="page"
              :pageCount="pageCount"
              @pageController="pageController"
          />
        </div>
      </div>

    </template>

    <at-modal-invoice-removed-efd
        v-if="isModalActiveInvoiceRemovedEfd"
        @closeModalInvoiceRemovedEfdParams="closeModalInvoiceRemovedEfd"
        @removedInvoiceEfdParams="cancelEfdInvoice"
    />

  </div>
</template>
<script>
import Vuex from "vuex";
import {API} from "@/utilites/api";
import ATLoader from "@/components/Loaders/Loader";
import {actionTypes as actionTypesInvoice, getterTypes as getterTypesInvoice} from "@/store/modules/invoices";
import {actionTypes as actionTypesAuth, getterTypes as getterTypesAuth} from "@/store/modules/auth";
import {format, parse} from "date-fns";
import {actionTypes as actionTypesPartners, getterTypes as getterTypesPartners} from "@/store/modules/partners";
import Lightpick from "lightpick";
import AtModalInvoiceRemovedEfd from "@/components/invoices/Modal/ModalInvoiceRemovedEfd";
import Pagination from "@/components/Pagination";
import {getCurrencySign} from '../../common/helpers/currency'
export default {
  name: 'AtEfdInvoice',
  props: ['user'],
  data(){
    return {
      isModalActiveInvoiceRemovedEfd: false,
      currentInvoice: {},
      tab: 0,
      now: new Date().toLocaleDateString(),
      API: API,
      page: 1,
      pageCount: 0,
      filterSearchInvoice: {
        userId: null,
        dateOfEfd: null,
        efd: false,
        paymentMethods: ["KASSA", "NMB", "EXIM", "EQUITY", "CRDB", "PAYPAL"]
      },
      pagination: {
        size: 25,
        page: 1
      }
    }
  },
  beforeCreate() {
    document.title = 'EFD Invoices'
  },
  components: {Pagination, AtModalInvoiceRemovedEfd, ATLoader},
  watch: {
    efdInvoice() {
      this.pageCountHandler()
    }
  },
  computed: {
    ...Vuex.mapGetters({
      efdInvoice: getterTypesInvoice.efdInvoice,
      sizeStatusInvoices: getterTypesInvoice.sizeStatusInvoices,
      isLoadingAllInvoices: getterTypesInvoice.isLoadingAllInvoices,
      allClients: getterTypesAuth.allClients,
      allPartners: getterTypesPartners.allPartners,
      newEfdInvoice: getterTypesInvoice.newEfdInvoice
    })
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      findSearchInvoices: actionTypesInvoice.findSearchInvoices,
      getAllClients: actionTypesAuth.getAllClients,
      patchTargetEfdInvoice: actionTypesInvoice.targetEfdInvoice,
      getAllPartners: actionTypesPartners.findPartners,
      filterEfdInvoice: actionTypesInvoice.filterEfdInvoice
    }),
    pageController(page) {
      this.page = page
      this.pagination.page = this.page
      this.findAllInvoices()
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.sizeStatusInvoices / this.pagination.size)
    },
    clearSearchInvoice(){
      // console.log('clearSearchInvoice')
      this.filterSearchInvoice.userId = null
      this.filterSearchInvoice.dateOfEfd = null

      this.findAllInvoices()
    },
    closeModalInvoiceRemovedEfd(value) {
      this.isModalActiveInvoiceRemovedEfd = value
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach((elem) => {
        elem.remove()
      })
      setTimeout(() => {
        document.querySelectorAll('.js-datepicker-single').forEach((item) => {
          const datePicker = new Lightpick({
            field: item,
            singleDate: true,
            lang: 'en',
            format: 'DD.MM.yyyy',
            onClose: function () {
              item.blur()
            },
            onSelect: function () {
              item.focus()
              item.blur()
            },
          })
          item.addEventListener('blur', () => {
            datePicker.hide()
          })
        })
      }, 1000)
    },
    searchInvoice() {
      // console.log('searchInvoice', this.filterSearchInvoice)
      this.findSearchInvoices({
        trackingTotalCount: true,
        filter: this.filterSearchInvoice,
        sort: {
          invoiceNumber: {
            order: "ASC"
          },
          deadline: {
            order: "ASC"
          }
        },
        pagination: {
          size: 25,
          page: this.pagination.page
        }
      }).then(() => this.findTabs(this.tab))
    },
    findNamePartners(invoice){
      if (invoice.payer.operatorId) {
        return this.allPartners.find(p => p.id === invoice.payer.operatorId).companyName
      }

      if (invoice.payer.participant) {
        return invoice.payer.participant
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    parseDateToString(date) {
      if (!date) return
      return format(parse(date, 'dd.MM.yyyy', new Date()), 'dd MMM yyyy')
    },
    cancelEfdInvoice(){
      // console.log('canselEfdInvoice', this.currentInvoice.id)
      // console.log('canselEfdInvoice', this.currentInvoice.efd)

      this.patchTargetEfdInvoice({
        id: this.currentInvoice.id,
        efd: !this.currentInvoice.efd,
        dateOfEFD: null
      }).then(() => {
        this.findAllInvoices()
      })

      this.isModalActiveInvoiceRemovedEfd = false
      this.currentInvoice = {}
    },
    targetEfdInvoice(invoice) {
      if (invoice.efd === false) {
        var now = new Date()
        function formatDate(date) {
          var dd = date.getDate();
          if (dd < 10) dd = '0' + dd;
          var mm = date.getMonth() + 1;
          if (mm < 10) mm = '0' + mm;
          var yy = date.getFullYear() % 100;
          if (yy < 10) yy = '0' + yy;
          return dd + '.' + mm + '.' + '20' + yy;
        }
        var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.patchTargetEfdInvoice({
          id: invoice.id,
          efd: !invoice.efd,
          dateOfEFD: formatDate(d)
        }).then(() => {
          this.findAllInvoices()
        })
      }
      if (invoice.efd === true) {
        this.currentInvoice = invoice
        this.isModalActiveInvoiceRemovedEfd = true
      }
    },
    findTabs(index) {
      if (index === 0) {
        this.filterSearchInvoice.efd = false
      }
      if (index === 1) {
        this.filterSearchInvoice.efd = true
      }
      this.findAllInvoices()
      this.tab = index
      this.page = 1
      // this.filterEfdInvoice(index)


      if (index === 1) {
        this.updateDatePickers()
      }
    },
    findAllInvoices() {
      this.findSearchInvoices(
          {
            trackingTotalCount: true,
            filter: {...this.filterSearchInvoice, paymentMethods: ["NMB", "EXIM", "EQUITY", "CRDB", "PAYPAL"]},
            sort: {
              invoiceNumber: {
                order: "ASC"
              },
              deadline: {
                order: "ASC"
              }
            },
            pagination: {
              size: 25,
              page: this.pagination.page
            }
          }
      ).then(() => {
        // this.findTabs(this.tab)
        this.findAllClients()
      })
    },
    findAllClients() {
      this.getAllClients()
    },
    findAllPartners() {
      this.getAllPartners().then(() => this.findAllInvoices())
    }
  },
  mounted() {
    this.findAllPartners()
    this.updateDatePickers()

    // Собираю новую дату для тестов

  }
}
</script>
